import { getFormattedMoney, roundToDecimals, formatFieldNumberValues } from '@/components/thanks-page/utils/helpers';

interface DebtAnalysis {
  isCalculationValid: string;
  term: number;
  monthlyRate: string;
  garnishmentAmount: string;
  potentialSavingDeEur: string;
}
export function calculateDebtAnalysis(answeredSlides: Record<string, string>): DebtAnalysis {
  const getPotentialSaving = (income: number, monthRate: number, months: number): number => {
    const potentialSaving = Math.floor(income) - Math.floor(roundToDecimals(monthRate)) * Math.ceil(months);
    return Number.isNaN(potentialSaving) || potentialSaving < 0 ? 0 : potentialSaving;
  };

  const getGesamtSchulden = (): number => {
    return getNumberFromInput(answeredSlides['gesamtschulden']);
  };

  const getNumberFromInput = (input: string): number => {
    if (!input) return 0;
    const matchDigits = formatFieldNumberValues(input);
    return parseInt(matchDigits);
  };

  const eingabeB6 = (): number => {
    return getGesamtSchulden();
  };

  const eingabeB5 = (): number => {
    if (answeredSlides['kinder'] && (answeredSlides['kinder'] == 'Nein' || answeredSlides['kinder'] == 'Sonstiges')) {
      return 0;
    }
    return getNumberFromInput(answeredSlides['kinderanzahl']);
  };

  const eingabeB1 = (): number => {
    if (!answeredSlides['einkommen']) {
      return 0;
    }
    return getNumberFromInput(answeredSlides['einkommen']);
  };

  const eingabeB2 = (): number => {
    if (!answeredSlides['einkommen-ehegatte']) {
      return 0;
    }
    return getNumberFromInput(answeredSlides['einkommen-ehegatte']);
  };

  const eingabeB3 = (): string => {
    return answeredSlides['familienstand'] ? answeredSlides['familienstand'] : 'Ledig';
  };

  const eingabeB4 = (): string => {
    return answeredSlides['veranschlagung'] && answeredSlides['veranschlagung'] == 'Gemeinsam'
      ? 'Gemeinsam'
      : 'Einzeln';
  };

  const berechnungB2 = (): number => {
    return Math.min(eingabeB1() * 0.1, 457);
  };

  const berechnungB3 = (): number => {
    return Math.min(eingabeB2() * 0.1, 457);
  };

  const berechnungB8 = (): 0 | 1 => {
    if (
      (eingabeB3() === 'Verheiratet' || eingabeB3() === 'Lebenspartnerschaft') &&
      eingabeB4() != 'Gemeinsam' &&
      eingabeB2() <= 700
    ) {
      return 1;
    }
    if (eingabeB4() === 'Gemeinsam' && (eingabeB2() <= 700 || eingabeB1() <= 700)) {
      return 1;
    }
    return 0;
  };

  const berechnungB9 = (): number => {
    return Math.min(berechnungB8() + eingabeB5(), 5);
  };

  const berechnungC12 = (): number => {
    if (berechnungB9() === 0) {
      return stepsB4();
    }

    return 0; // false;
  };

  const berechnungB14 = (): number => {
    return berechnungB2() - (berechnungB12() + 150);
  };

  const berechnungC10 = (): number => {
    if (berechnungB9() === 0) {
      return stepsB2();
    }
    return 0; // false
  };

  const stepsC2 = (): number => {
    return 5;
  };

  const stepsD2 = (): number => {
    return 4;
  };

  const stepsE2 = (): number => {
    return 3;
  };

  const stepsF2 = (): number => {
    return 2;
  };

  const stepsG2 = (): number => {
    return 1;
  };

  const berechnungD10 = (): number => {
    if (berechnungB9() === 1) {
      return stepsC2();
    }
    return 0; // false
  };

  const berechnungE10 = (): number => {
    if (berechnungB9() === 2) {
      return stepsD2();
    }
    return 0; // false
  };

  const berechnungF10 = (): number => {
    if (berechnungB9() === 3) {
      return stepsE2();
    }
    return 0; // false
  };

  const berechnungG10 = (): number => {
    if (berechnungB9() === 4) {
      return stepsF2();
    }
    return 0; // false
  };

  const berechnungH10 = (): number => {
    if (berechnungB9() === 5) {
      return stepsG2();
    }
    return 0; // false
  };

  const berechnungB10 = (): number => {
    return berechnungC10() + berechnungD10() + berechnungE10() + berechnungF10() + berechnungG10() + berechnungH10();
  };

  const berechnungB5 = (): number => {
    if (eingabeB1() - 4573.1 < 0) {
      return 0;
    }
    return eingabeB1() - 4573.1;
  };

  const berechnungC11 = (): number => {
    if (berechnungB9() === 0) {
      return stepsB3();
    }
    return 0; // false
  };

  const stepsB3 = (): number => {
    return 5.78;
  };

  const stepsC3 = (): number => {
    return 3.68;
  };

  const stepsD3 = (): number => {
    return 1.83;
  };

  const stepsE3 = (): number => {
    return 0.54;
  };

  const stepsF3 = (): number => {
    return 1.8;
  };

  const stepsG3 = (): number => {
    return 0.62;
  };

  const berechnungD11 = (): number => {
    if (berechnungB9() === 1) {
      return stepsC3();
    }
    return 0; // false
  };

  const berechnungE11 = (): number => {
    if (berechnungB9() === 2) {
      return stepsD3();
    }
    return 0; // false
  };

  const berechnungF11 = (): number => {
    if (berechnungB9() === 3) {
      return stepsE3();
    }
    return 0; // false
  };

  const berechnungG11 = (): number => {
    if (berechnungB9() === 4) {
      return stepsF3();
    }
    return 0; // false
  };

  const berechnungH11 = (): number => {
    if (berechnungB9() === 5) {
      return stepsG3();
    }
    return 0; // false
  };

  const berechnungB11 = (): number => {
    return berechnungC11() + berechnungD11() + berechnungE11() + berechnungF11() + berechnungG11() + berechnungH11();
  };

  const stepsB4 = (): number => {
    return 0;
  };

  const stepsC4 = (): number => {
    return 56;
  };

  const stepsD4 = (): number => {
    return 87;
  };

  const stepsE4 = (): number => {
    return 118;
  };

  const stepsF4 = (): number => {
    return 150;
  };

  const stepsG4 = (): number => {
    return 181;
  };

  const berechnungD12 = (): number => {
    if (berechnungB9() === 1) {
      return stepsC4();
    }
    return 0; // false
  };

  const berechnungE12 = (): number => {
    if (berechnungB9() === 2) {
      return stepsD4();
    }
    return 0; // false
  };

  const berechnungF12 = (): number => {
    if (berechnungB9() === 3) {
      return stepsE4();
    }
    return 0; // false
  };

  const berechnungG12 = (): number => {
    if (berechnungB9() === 4) {
      return stepsF4();
    }
    return 0; // false
  };

  const berechnungH12 = (): number => {
    if (berechnungB9() === 5) {
      return stepsG4();
    }
    return 0; // false
  };

  const berechnungB12 = (): number => {
    return berechnungC12() + berechnungD12() + berechnungE12() + berechnungF12() + berechnungG12() + berechnungH12();
  };

  const berechnungB6 = (): number => {
    if (eingabeB2() - 4573.1 < 0) {
      return 0;
    }
    return eingabeB2() - 4573.1;
  };

  const berechnungB15 = (): number => {
    return berechnungB3() - (berechnungB12() + 150);
  };

  const berechnungB18 = (): number => {
    let rv1 = 0;
    if (berechnungB3() >= 150 + berechnungB12()) {
      rv1 = berechnungB15() * berechnungB10() + berechnungB6() + berechnungB11();
    }
    return Math.max(rv1, 0);
  };

  const berechnungB17 = (): number => {
    let rv = 0;
    if (berechnungB2() >= 150 + berechnungB12()) {
      rv = berechnungB14() * berechnungB10() + berechnungB5() + berechnungB11();
    }
    return Math.max(rv, 0);
  };

  const berechnungB20 = (): number => {
    if (eingabeB4() === 'Einzeln') {
      return berechnungB17();
    }
    return berechnungB17() + berechnungB18();
  };

  const stepsB2 = (): number => {
    return 7;
  };

  const eingabeB8 = (): number => {
    return berechnungB20();
  };

  const eingabeB10 = (): number => {
    if (preSum() + eingabeB9() < 50) {
      return 40;
    }
    return preSum() + eingabeB9();
  };

  const preSum = (): number => {
    if (eingabeB6() * (0.3 / 36) >= eingabeB8()) {
      return eingabeB6() * (0.3 / 36);
    }
    return eingabeB8();
  };

  const eingabeB9 = (): 25 | 50 => {
    if (preSum() < 500) {
      return 25;
    }
    if (preSum() >= 500) {
      return 50;
    }
    return 50;
  };

  const eingabeB15 = (): number => {
    return 36;
  };

  const eingabeB11 = (): number => {
    if ((eingabeB10() - eingabeB9()) * eingabeB15() <= eingabeB6()) {
      return (eingabeB10() - eingabeB9()) * eingabeB15();
    }

    return eingabeB6();
  };

  const eingabeB7 = (): number => {
    if (eingabeB11() === eingabeB6()) {
      return eingabeB11() / eingabeB10();
    }
    return 36;
  };

  const eingabeC10 = (): number => {
    if (eingabeB10() > eingabeB6()) {
      return eingabeB6() + eingabeB9();
    }
    return eingabeB10();
  };

  const eingabeD10 = (): number => {
    if (eingabeC10() > 0) {
      return eingabeC10();
    }
    return 1;
  };

  const potentialSaving = getPotentialSaving(eingabeB6(), eingabeC10(), eingabeB7());

  return {
    isCalculationValid: getFormattedMoney(eingabeD10()),
    term: eingabeB7(),
    monthlyRate: getFormattedMoney(roundToDecimals(eingabeC10())),
    garnishmentAmount: getFormattedMoney(eingabeB8()),
    potentialSavingDeEur: getFormattedMoney(potentialSaving),
  };
}
